import { Either } from 'monet';
import LeftResponse from '@/storage/LeftResponse';

/**
 * @description Шлюз виджета онлайн-записи на прием.
 * @param {import('axios').AxiosInstance} axios HTTP клиент.
 * @constructor
 */
export default function AppointmentBookingWidgetGateway(axios) {
  /**
   * @description Показать виджет.
   * @returns {Promise<Either>}
   */
  this.viewWidget = () => axios
    .get('/api/appointment-booking-widget')
    .then(
      (response) => Either.right({
        widget: response.data.data,
        options: response.data.options,
      }),
      (error) => {
        if (error.isAxiosError && error.response.status === 403) {
          return Either.left(error.response.data.title);
        }
        throw error;
      },
    );
  /**
   * @description Создать виджет.
   * @param {any} request Запрос.
   * @returns {Promise<Either>}
   */
  this.createWidget = (request) => axios
    .post('/api/appointment-booking-widget', request)
    .then(
      (response) => Either.right(response.data),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          const { causes, title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.left(leftResponse);
        }
        throw error;
      },
    );
  /**
   * @description Редактировать виджет.
   * @param {any} request Запрос.
   * @returns {Promise<Either>}
   */
  this.editWidget = (request) => axios
    .put('/api/appointment-booking-widget', request)
    .then(
      (response) => Either.right(response.data),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          const { causes, title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.left(leftResponse);
        }
        throw error;
      },
    );
  /**
   * @description Отключить сотрудника.
   * @param {number} employeeId Идентификатор сотрудника.
   * @returns {Promise<Either<{title},{title}>>}
   */
  this.disableEmployee = (employeeId) => axios
    .delete(`/api/appointment-booking-widget/employees/${employeeId}`)
    .then(
      async (response) => Either.right(response.data),
      async (error) => {
        if (error.isAxiosError && error.response.status === 400) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );
  /**
   * @description Включить сотрудника.
   * @param {number} employeeId Идентификатор сотрудника.
   * @returns {Promise<Either<{title},{title}>>}
   */
  this.enableEmployee = (employeeId) => axios
    .post(`/api/appointment-booking-widget/employees/${employeeId}`)
    .then(
      async (response) => Either.right(response.data),
      async (error) => {
        if (error.isAxiosError && error.response.status === 400) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );
}
